// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { EMonitoringScopeSelector } from "./types";
var SELECTORS = Object.values(EMonitoringScopeSelector);
/** On an election's page its Post is fixed, and with it the Post's Region. */
var PINNED_BY_POST = new Set([
    EMonitoringScopeSelector.REGION,
    EMonitoringScopeSelector.POST,
]);
/**
 * The scope a preview draws for: the viewer's choices for the selectors
 * the dashboard offers, without the Post and its Region on an election's
 * page (the election pins them), and the whole event while the dashboard is unknown.
 */
export var previewScope = function (chosen, dashboard, electionId) {
    var offered = dashboard && typeof dashboard === "object" && !Array.isArray(dashboard)
        ? dashboard.selectors
        : undefined;
    var selectors = Array.isArray(offered) ? offered : [];
    var scope = {};
    for (var _i = 0, SELECTORS_1 = SELECTORS; _i < SELECTORS_1.length; _i++) {
        var selector = SELECTORS_1[_i];
        var value = chosen[selector];
        if (!value || !selectors.includes(selector))
            continue;
        if (electionId && PINNED_BY_POST.has(selector))
            continue;
        scope[selector] = value;
    }
    return scope;
};
